import { j as A } from "../../../../jsx-runtime.BREq8dyb.js";
import { Box as C } from "@mui/joy";
import { b as j } from "../../../../lodash.DGoHQECz.js";
import { p as I } from "../../../../papaparse.Bp2NUwP6.js";
import { memo as S, useRef as $, useState as k, useCallback as b, useEffect as B } from "react";
import { useErrorBoundary as P } from "react-error-boundary";
import R, { PromiseState as T } from "../../../Loader/Loader.js";
import "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import { useFile as H } from "../../contexts/FileContext/FileContext.js";
import { IntrospectingProvider as L } from "../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../contexts/NavigatorContext/NavigatorContext.js";
import "../../contexts/OptionsContext/OptionsContext.js";
import { useSchema as D } from "../../contexts/SchemaContext/SchemaContext.js";
import "../../contexts/TypificationContext/TypificationContext.js";
import "../../contexts/WorkerContext/WorkerContext.js";
import { guessFormatType as w } from "../../utils/index.js";
const V = async (h, {
  delimiter: m,
  header: s
}) => new Promise((u) => {
  I.parse(h, {
    delimiter: m,
    dynamicTyping: !1,
    header: s,
    skipEmptyLines: !0,
    step: (p, c) => {
      c.abort();
      const {
        data: e,
        meta: g
      } = p || {}, {
        delimiter: f,
        fields: t
      } = g || {};
      u({
        columns: Array.isArray(t) && t.length > 0 ? t.map((o, r) => ({
          formatType: w(e?.[o]),
          id: `column-${r}`,
          name: o,
          nullable: !0
        })) : Array.isArray(e) && e.length > 0 ? e.map((o, r) => ({
          formatType: w(o),
          id: `column-${r}`,
          name: `Column ${(r + 1).toString()}`,
          nullable: !0
        })) : void 0,
        delimiter: f,
        headers: Array.isArray(t) && t.length > 0 ? t : Array.isArray(e) && e.length > 0 ? e.map((o, r) => `Column ${(r + 1).toString()}`) : void 0
      });
    },
    worker: !0
  });
}), q = S(({
  children: h
}) => {
  const {
    showBoundary: m
  } = P(), {
    file: s,
    fileHasHeader: u,
    fileValuesDelimiter: p,
    setFileHeaders: c,
    setFileValuesDelimiter: e
  } = H(), {
    schema: g,
    setSchema: f
  } = D(), {
    current: t
  } = $(g !== null), [o, r] = k(!1), E = b(async (n, d, i) => await V(n, {
    delimiter: i,
    header: d
  }), []), v = b((n = void 0, d = void 0) => {
    if (s && t)
      return r(!0), E(s, u, p).then((i) => {
        if (i) {
          const {
            delimiter: F,
            headers: a
          } = i;
          f((x) => {
            if (a && x) {
              const {
                columns: l
              } = x;
              for (let y = a.length; y < l.length && l?.[y]?.default !== void 0; y++)
                a.push(`Column ${(y + 1).toString()}`);
            }
            return d?.() && (e(F), c((l) => j(l, a) ? l : a)), x;
          });
        }
        return i;
      }).catch((i) => {
        m(new Error("Failed to introspect file"));
      }).finally(() => {
        d?.() && r(!1);
      });
  }, [s, t, E, u, p, f, e, c, m]);
  return B(() => {
    let n = !0;
    return v(void 0, () => n), () => {
      n = !1;
    };
  }, [v]), /* @__PURE__ */ A.jsx(L, { value: {
    introspect: v,
    introspecting: o,
    setIntrospecting: r
  }, children: o ? /* @__PURE__ */ A.jsx(C, { sx: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    width: "100%"
  }, children: /* @__PURE__ */ A.jsx(R, { loadLabel: "Guessing file format…", loadState: T.Pending }) }) : h });
});
q.displayName = "IntrospectionContainer";
export {
  q as default
};
//# sourceMappingURL=IntrospectionContainer.js.map
